export enum ErrorApiCodes {
  // GENERIC EXCEPTIONS:
  USER_NOT_AUTHORIZED = 'USER_NOT_AUTHORIZED',
  RESPONSIBILITY_CHAIN_NOT_RETRIEVE = 'RESPONSIBILITY_CHAIN_NOT_RETRIEVE',
  VALIDATOR_FAILURE = 'VALIDATOR_FAILURE',
  CONSTRAINT_VIOLATION_FAILURE = 'CONSTRAINT_VIOLATION_FAILURE',
  CONFLICT = 'CONFLICT',
  INVALID_FORMAT = 'INVALID_FORMAT',
  BAD_REQUEST = 'BAD_REQUEST',
  VALIDATION_ERROR = 'VALIDATION_ERROR',
  GENERIC_EXCEPTION = 'GENERIC_EXCEPTION',

  // USERS:
  SAVIOO_ADMIN_CANNOT_CREATE_USER_SAME_ROLE = 'SAVIOO_ADMIN_CANNOT_CREATE_USER_SAME_ROLE',
  UNAUTHORIZED_ERROR_ONLY_SAVIOO_ADMIN = 'UNAUTHORIZED_ERROR_ONLY_SAVIOO_ADMIN',
  USER_ALREADY_EXISTS = 'USER_ALREADY_EXISTS',
  USERNAME_ALEADY_EXISTS = 'USERNAME_ALEADY_EXISTS',
  MULTIPLE_CANDIDATES_BY_USER_ID = 'MULTIPLE_CANDIDATES_BY_USER_ID',
  MULTIPLE_CANDIDATES_FOR_USER = 'MULTIPLE_CANDIDATES_FOR_USER',
  AUTH_USER_NOT_FOUND = 'AUTH_USER_NOT_FOUND',
  USER_NOT_FOUND = 'USER_NOT_FOUND',
  USER_NOT_FOUND_BY_EMAIL = 'USER_NOT_FOUND_BY_EMAIL',
  USER_NOT_FOUND_DELETED_AND_EMAIL = 'USER_NOT_FOUND_DELETED_AND_EMAIL',
  USER_EMAIL_UPDATE_ERROR = 'USER_EMAIL_UPDATE_ERROR',
  USER_REACTIVATE_ERROR = 'USER_REACTIVATE_ERROR',
  USER_DEACTIVATE_ERROR = 'USER_DEACTIVATE_ERROR',
  USER_GET_ALL_ERROR = 'USER_GET_ALL_ERROR',
  CREATE_USER_ERROR = 'CREATE_USER_ERROR',
  AUTH_EXTERNAL_REQUEST_AUTH_USER_NOT_FOUND = 'AUTH_EXTERNAL_REQUEST_AUTH_USER_NOT_FOUND',
  AUTH_EXTERNAL_REQUEST_AUTH_USER = 'AUTH_EXTERNAL_REQUEST_AUTH_USER',
  AUTH_EXTERNAL_REQUEST_CONFIRMED_NOT_FOUND = 'AUTH_EXTERNAL_REQUEST_CONFIRMED_NOT_FOUND',
  AUTH_EXTERNAL_REQUEST_CONFIRMED = 'AUTH_EXTERNAL_REQUEST_CONFIRMED',
  AUTH_EXTERNAL_REQUEST_PROPOSED_EMAIL = 'AUTH_EXTERNAL_REQUEST_PROPOSED_EMAIL',
  AUTH_EXTERNAL_REQUEST_DEACTIVATE_USER = 'AUTH_EXTERNAL_REQUEST_DEACTIVATE_USER',
  AUTH_EXTERNAL_REQUEST_REACTIVATE_USER = 'AUTH_EXTERNAL_REQUEST_REACTIVATE_USER',
  AUTH_EXTERNAL_REQUEST_UPDATE_INSTALLATION = 'AUTH_EXTERNAL_REQUEST_UPDATE_INSTALLATION',
  AUTH_EXTERNAL_REQUEST_UPDATE_USER_INFO = 'AUTH_EXTERNAL_REQUEST_UPDATE_USER_INFO',
  AUTH_EXTERNAL_REQUEST_RESPONSIBILITY_CHAIN = 'AUTH_EXTERNAL_REQUEST_RESPONSIBILITY_CHAIN',

  // INSTALLATIONS:
  INSTALLATION_WORKSPACE_CONFLICT = 'INSTALLATION_WORKSPACE_CONFLICT',
  INSTALLATION_SIFARMA_PHARMACY_CODE_CONFLICT = 'INSTALLATION_SIFARMA_PHARMACY_CODE_CONFLICT',
  CANNOT_DELETE_ROBOT_TYPE_IN_USE = 'CANNOT_DELETE_ROBOT_TYPE_IN_USE',

  // CENTERS:
  CONFLICT_TREATMENT_TYPE_INTEGRATION_ALREADY_PRESENT = 'CONFLICT_TREATMENT_TYPE_INTEGRATION_ALREADY_PRESENT',
  USER_NOT_ENOUGH_PERMISSIONS = 'USER_NOT_ENOUGH_PERMISSIONS',

  // ROBOT TYPES:
  ROBOT_TYPE_NOT_FOUND_BY_ID = 'ROBOT_TYPE_NOT_FOUND_BY_ID',
  ROBOT_TYPE_MODEL_CONFLICT = 'ROBOT_TYPE_MODEL_CONFLICT',
  ROBOT_TYPE_INVALID_PATIENTS_RANGE = 'ROBOT_TYPE_INVALID_PATIENTS_RANGE',
  ROBOT_TYPE_IN_USE = 'ROBOT_TYPE_IN_USE',
}
